export default __webpack_public_path__ + "static/media/fluidity-100-ig-edit-4558.c434c93a.mp3";